export default {"src":"/_next/static/media/avatar.5eb6327d.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};